export function isNullOrUndefined(value: any):boolean {
    return value === null || value === undefined;
}

export function isNotNullOrEmpty(value: string | null | undefined): boolean {
    return value !== null && value !== undefined && value.trim().length > 0;
}

export function isNullOrWhiteSpace(value: string | null | undefined): boolean {
    if (!value || value === null || value === undefined) {
        return true;
    }

    if (!value.trim() || value.trim().length === 0) {
        return true;
    }

    return false;
}

export function isEmail(email: string): boolean {
    return /^[a-zA-Z0-9]+([._+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(-?[a-zA-Z0-9]+)*(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/i.test(email);
}

export function isPhone(phone: string): boolean {
    if (!phone.trim()) return false;

    //https://stackabuse.com/validate-phone-numbers-in-javascript-with-regular-expressions/
    const iePattern = new RegExp("\\+353\\(0\\)\\s\\d\\s\\d{3}\\s\\d{4}");
    //const ukPattern = new RegExp("\\+353\\(0\\)\\s\\d\\s\\d{3}\\s\\d{4}");
    if (iePattern.test(phone)) { //|| ukPattern.test(phone)) {
        return true;
    } else {
        return false;
    }

    //return /^(\d{3}[-]?){1,2}(\d{4})$/.test(phone);
    //const pattern = new RegExp("^[+]{1}(?:[0-9\\-\\(\\)\\/\\.]\\s?){6, 15}[0-9]{1}$");
    //return pattern.test(phone);
}

export function hasXSSCharacters(input:string):boolean {
    const xssPattern = /[<>&]/;
    return xssPattern.test(input);
}

export function generate_uuidv4():string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
        function (c) {
            const uuid = Math.random() * 16 | 0, v = c == 'x' ? uuid : (uuid & 0x3 | 0x8);
            return uuid.toString(16);
        });
}

export function isVideoFile(filePath: string) {
    // Extract the file extension from the URL
    const fileExtension = filePath.split('.').pop().toLowerCase();
    const videoFileExtensions = ['mp4', 'm4v', 'mov', 'avi', 'mkv', 'webm', 'mpg'];

    if (videoFileExtensions.includes(fileExtension)) {
        return true;
    }

    return false;
}

export function isImageFile(filePath: string) {
    // Extract the file extension from the URL
    const fileExtension = filePath.split('.').pop().toLowerCase();

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)) {
        return true;
    }

    return false;
}

export function getVideoDuration(file: File): Promise<number> {
    if (file) {
        console.debug("getVideoDuration");
        const url = URL.createObjectURL(file);
        console.debug("url: ", url);

        return new Promise((resolve) => {
            const audio = document.createElement("audio");
            audio.muted = true;
            const source = document.createElement("source");
            source.src = url; //--> blob URL
            audio.preload = "metadata";
            audio.appendChild(source);
            audio.onloadedmetadata = function () {
                resolve(audio.duration)
            };
        });
    }
}

export function formatStringWithPlaceholders(text: string, ...values: string[]): string {
    if (!text) {
        return "";
    }

    return text.replace(/{(\d+)}/g, (match, index) => {
        return typeof values[index] !== 'undefined' ? values[index] : match;
    });
}

export function isFullNameValid(fullName: string): boolean {
    if (!fullName || !fullName.trim()) {
        return false;
    }

    const regex = /^([\p{L}][\p{L}'-]{0,49}( [\p{L}][\p{L}'-]{0,49}){1,})?$/u;
    return regex.test(fullName);
}